import { MessageResponse } from "client/openapi";

/**
 * Who sees a message kept to some admins (mail that came in through their
 * personal addresses), in words: "you", "you and Bob Smith", or "you, Bob
 * Smith, and Cat Jones". Undefined for a message every admin sees.
 */
export function privateTo(
  message: MessageResponse | undefined,
  me: string | undefined
): string | undefined {
  const viewers = message?.private_to;
  if (!viewers?.length) return undefined;
  const others = viewers
    .filter((viewer) => viewer.reference_id !== me)
    .map((viewer) => `${viewer.first_name} ${viewer.last_name}`.trim());
  const names = [...(others.length < viewers.length ? ["you"] : []), ...others];
  if (names.length <= 2) return names.join(" and ");
  return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`;
}

/** "Only you see this.", "Only you and Bob Smith see this.", and so on. */
export function privateNote(
  message: MessageResponse | undefined,
  me: string | undefined
): string | undefined {
  const who = privateTo(message, me);
  if (!who) return undefined;
  const verb = who === "you" || who.includes(" and ") ? "see" : "sees";
  return `Only ${who} ${verb} this.`;
}
